<!--
 * @Author: vince
 * @Date: 2021-08-31 19:07:07
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2023-06-15 11:27:58
 * @Description:
-->

<template>
  <div class="sys-box">
    <el-container style="height: 100%">
      <el-aside width="200px">
        <el-menu
          :default-active="active"
          text-color="#000"
          active-text-color="#fff"
          class="border-none"
          @select="menuSelect"
        >
          <el-menu-item index="extraTrainingExamine">
            <span class="menu-label" slot="title">校外培训</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <router-view></router-view>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    active() {
      return this.$route.name
    }
  },

  methods: {
    menuSelect(index, indexPath) {
      this.$router.push({ name: index })
    }
  }
}
</script>

<style lang='less'>
</style>
